class FansyGallery {
    constructor() {
        this.catchGalleries()
    }

    catchGalleries() {
        const galleryList = document.querySelectorAll('.fansy-gallery');

        if (galleryList) {
            galleryList.forEach(gallery => {
                this.addListeners(gallery)
            })
        }
    }

    addListeners(gallery) {
        const arrows = gallery.querySelectorAll('.arrow')
        const pins = gallery.querySelectorAll('.fansy-pin')

        arrows.forEach(arrow => {
            arrow.addEventListener('click', () => {
                const id = this.getNewId(arrow.dataset.type, pins);
                this.switchById(gallery, pins, id)
            })
        })

        pins.forEach(pin => {
            pin.addEventListener('click', () => {
                this.switchById(gallery, pins, pin.dataset.id)
            })
        })
    }

    getNewId(type, pins) {

        let id = 0;
        let newId = 0;
        let counter = -1;

        pins.forEach(pin => {
            counter++;
            if (pin.classList.contains('fansy-pin--checked')) {
                id = pin.dataset.id
            } 
        })

    
        if (type == 'left') {
            if (+id > 0 ) {
                newId = +id - 1;
            } else {
                newId = counter;
            }
        }

        if (type == 'right') {
            if (+id < counter ) {
                newId = +id + 1;
            } else {
                newId = 0;
            }
        }
        
        console.log(newId)

        return newId
    }

    switchById(gallery, pins, id) {
        const items = gallery.querySelectorAll('.fansy-item')

        items.forEach(item => {
            if (+item.dataset.id == +id) {
                item.classList.remove('fansy-item--hidden')
            } else {
                item.classList.add('fansy-item--hidden')
            }
        })

        pins.forEach(pin => {
            if (+pin.dataset.id == +id) {
                pin.classList.add('fansy-pin--checked')
            } else {
                pin.classList.remove('fansy-pin--checked')
            }
        })
    }
}

export default FansyGallery